import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propNumber, propStr } from '../../../helpers/custom-prop-types';
/**
 * 数字をK（1,000）やM（1,000,000）の単位で丸めて表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const RoundNumberText = (props) => {
    const { className, number: rawNumber } = props;
    // SQL改善までの一時的な修正
    // const {
    //   number,
    //   unit,
    // } = useMemo(() => {
    //   if (rawNumber > 999999999) {
    //     return {
    //       number: 999,
    //       unit: 'M',
    //     };
    //   }
    //   if (rawNumber >= 100000000 && rawNumber <= 999999999) {
    //     return {
    //       number: Math.floor(rawNumber / 1000000),
    //       unit: 'M',
    //     };
    //   }
    //   if (rawNumber >= 10000000 && rawNumber <= 99999999) {
    //     return {
    //       number: (Math.floor((rawNumber / 1000000) * 10) / 10).toFixed(1),
    //       unit: 'M',
    //     };
    //   }
    //   if (rawNumber >= 1000000 && rawNumber <= 9999999) {
    //     return {
    //       number: (Math.floor((rawNumber / 1000000) * 100) / 100).toFixed(2),
    //       unit: 'M',
    //     };
    //   }
    //   if (rawNumber >= 100000 && rawNumber <= 999999) {
    //     return {
    //       number: Math.floor(rawNumber / 1000),
    //       unit: 'K',
    //     };
    //   }
    //   return {
    //     number: rawNumber.toLocaleString(),
    //     unit: '',
    //   };
    // }, [rawNumber]);
    return (_jsxs("span", Object.assign({ className: clsx('round_number_text', className) }, { children: [_jsx("span", Object.assign({ className: 'text_number' }, { children: rawNumber.toLocaleString() })), _jsx("span", { className: 'text_unit' })] })));
};
RoundNumberText.propTypes = {
    className: propStr(),
    number: propNumber().isRequired,
};
RoundNumberText.defaultProps = {
    className: '',
};
export default RoundNumberText;
